export default "__VITE_ASSET__BqZKo_sH__"